export const GLOBAL_REQ_CANCEL = 'GLOBAL_REQ_CANCEL';
export const SIGNUP_NEW = 'SIGNUP_NEW';
export const SIGNUP_INVITED = 'SIGNUP_INVITED';
export const CHECK_EXISTING_TEAM = 'CHECK_EXISTING_TEAM';
export const GET_USER_FROM_SESSION = 'GET_USER_FROM_SESSION';
export const GET_USER_BY_INVITE_TOKEN = 'GET_USER_BY_INVITE_TOKEN';
export const RESEND_INVITE_TOKEN = 'RESEND_INVITE_TOKEN';
export const INIT_FEATURE_FLAGS = 'INIT_FEATURE_FLAGS';
export const SET_FEATURE_FLAGS = 'SET_FEATURE_FLAGS';
export const CREATE_PASSWORD_RECOVERY_TOKEN = 'CREATE_PASSWORD_RECOVERY_TOKEN';
export const UPDATE_PASSWORD_FROM_RECOVERY_TOKEN =
  'UPDATE_PASSWORD_FROM_RECOVERY_TOKEN';
export const GET_MFA_STATUS = 'GET_MFA_STATUS';
export const LOGIN = 'LOGIN';
export const GET_SSO_LOGIN_REQUIRED = 'GET_SSO_LOGIN_REQUIRED';
export const VERIFY_USER_EMAIL = 'VERIFY_USER_EMAIL';
export const DISMISS_SIGNUP_ERROR = 'DISMISS_SIGNUP_ERROR';
